var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aboutUsBox"},[_c('nav-bar',{attrs:{"title":_vm.$t('关于我们'),"bg-color":"#446D7A","left-arrow":"","left-color":"#fff","title-color":"#fff"}}),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }